import * as FluxUtils from 'flux/utils';
import { AppDispatcher, DispatcherBaseAction } from '../dispatcher/AppDispatcher';
import { ActionConstants } from '../constants/ActionConstants';
import { PopupFlagPosition } from '../constants/PopupFlagPositions';

import core = egr.wcf.core;

export enum OAPLevel {
    Classes = 0,
    Properties = 1,
    Values = 2
}

export interface OAPPositionSetting {
    top: number;
    left: number;
    flagPosition: PopupFlagPosition;
}

export interface OAPStoreState {
    showEditor: boolean;

    title?: string;

    classes: Array<core.prop.PropertyClass>;

    selectedClass: core.prop.PropertyClass | null;
    properties: Array<core.prop.Property>;

    selectedProperty: core.prop.Property | null;
    values: Array<core.prop.PropertyValue>;

    position: OAPPositionSetting;

    startLevel: OAPLevel;

    actions: Array<core.AppCallbacks.ChoiceAction>;
    actionOptions: core.AppCallbacks.ShowActionChoiceOptions | null;
}

class OAPStoreClass extends FluxUtils.ReduceStore<OAPStoreState, any> {
    public getInitialState(): OAPStoreState {
        return {
            showEditor: false,
            title: '',
            classes: [],
            selectedClass: null,
            properties: [],
            selectedProperty: null,
            values: [],
            position: {top: 0, left: 0, flagPosition: PopupFlagPosition.TOPLEFT},
            startLevel: OAPLevel.Classes,
            actions: [],
            actionOptions: null
        };
    }

    public reduce(state: OAPStoreState, action: DispatcherBaseAction): OAPStoreState {
        // Note: this function should be `pure` -> we have to return a copy
        // of the current state if some property was changed

        switch (action.actionType) {
            case ActionConstants.OAP_UPDATE:
                return jQuery.extend({}, action.value);
            case ActionConstants.OAP_DESTROY:
                return this.getInitialState();
            case ActionConstants.OAP_SET_CLASS:
                return jQuery.extend({}, state, { selectedClass: action.value, values: new Array(), selectedProperty: null});
            case ActionConstants.OAP_SET_PROPERTY:
                return jQuery.extend({}, state, {
                    selectedProperty: action.value.property,
                    values: action.value.values
                });
            case ActionConstants.OAP_POSITION:
                return jQuery.extend({}, state, { position: action.value});
            default:
                return state;
        }
    }
}

export let OAPStore: OAPStoreClass = new OAPStoreClass(AppDispatcher);


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/stores/OAPStore.ts